export default __webpack_public_path__ + "static/media/block-services-2.c534e61c.webp";